import React from 'react'
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import '../assets/css/header.css'
import image1 from '../assets/images/footer1.jpg'

import { Link } from 'react-router-dom';

export default function Header(props) {
    const options = {
        loop: true,
        // autoHeight: true,
        margin: 20,
        autoplay: true,
        smartSpeed: 1000,
        autoplayTimeout: 6000,
        autoplayHoverPause: true,
        items: 1,
        nav: true,
        navText: [
          "<i class='fa fa-chevron-left'></i>", "<i class='fa fa-chevron-right'></i>",
        ],
        responsive: {

            1000: {
                stagePadding: 300
            },
            900: {
                stagePadding: 250
            },
            800: {
                stagePadding: 200
            },
            700: {
                stagePadding: 150
            },
            600: {
                stagePadding: 100,
            },
            500: {
                stagePadding: 0,
            },
        },
        touchDrag: true,
        mouseDrag: true,
        pullDrag: true,
      };

      const carouselItems = props.data;

  return (
    <div className='carouselOwl'>
    <OwlCarousel className="owl-theme" {...options}>
      {carouselItems.map((item, index) => (
        <div className='item' key={index}>
          <Link to={`/recipe/${item.id}`}>
            <div className='image-container'>
              <img src={item.image} alt={`Image ${index + 1}`} />
            </div>
            <div className='caption'>
              <div className='heading'>{item.heading}</div>
              <div className='content'>{item.content}</div>
            </div>
          </Link>
        </div>
      ))}
    </OwlCarousel>
  </div>
  )
}
